import React, { useState, useContext } from 'react';
import { DatePicker, CustomChip, SpeedDials } from '../../../../../Core/Controls';
import CustomizedTables from '../../../../../Core/Controls/Table';
import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import AddEditDepots from './addEditDepots';
import { DepotProvider, DepotScreenContext } from './depotProvider';
import FileUploaderButton from '../../../../../Core/Controls/GenericFileUploader';
import { formatters } from '../../../../../Core/Controls';
import { AppStorage } from '../../../../../Core/Basic/storage-service';
import StickyNotes from '../../Notes/stickyNotes';
import AllStickyNotes from '../../Notes/stickyAllNotes';
import { CustomButtonChip } from '../../../../../Core/Controls/Inputs/DatePicker';

const EditDepotDash = (props) => {
    let getAccessParam = AppStorage.getAllowAcces();
    const {
        scheduleFields,
        handleSubmit,
        scheduleDetailsChange,
        handleCheckbox,
        closeModal,
        handledepotFields,
        handledepotCheckbox,
        depotFields,
        handleActive,
        pullDepotData

    } = useContext(DepotScreenContext);

    const [state, setstate] = useState({});
    const handleAddPopUp = (id, name) => {
        setstate((st) => ({ ...st, [name]: true, VehicleID: id }));
    };

    const isValue = (val) => {
        return val ? val : 'N/A';
    };
    const newLineValue = (val) => {
        return val
            ? val.split('\n').map((line, index) => (
                <React.Fragment key={index}>
                    {line}
                    <br />
                </React.Fragment>
            ))
            : 'N/A';
    };
    const isYesNo = (val) => {
        return val ? 'Yes' : 'No';
    };
    const EmptyVal = (val) => {
        return <div>&nbsp;</div>;
    };
    const tableData = [
        {
            name1: 'Address',
            value1: formatters.addressFormatter(
                depotFields.address1,
                depotFields.address2,
                depotFields.depotTown,
                depotFields.depotPostCode,
                depotFields.depotCounty
            )
            // name2: 'Telephone',
            // value2: formatters.phoneNumberFormatter(depotFields.depotTelephone),
            // name3: 'Contact Number',
            // value3: formatters.phoneNumberFormatter(depotFields.depotContact),
            // name4: 'Email',
            // value4: formatters.mailFormatter(depotFields.depotEmail)
        },
        { name1: 'Notes', value1: newLineValue(depotFields.depotNotes) }

    ];

    const Header = () => {
        return (
            <Grid container alignItems="center" justify="space-between" >
                <Grid xs={12} sm md={6} item>
                    <Typography variant="h6" color="secondary">
                        Depot Details: {depotFields.name}
                    </Typography>
                </Grid>
                <Grid item >
                    <div className="dash-controller-btn" style={{ display: 'flex', padding: 10 }}>
                        <span style={{ marginTop: -7 }}>
                            <FileUploaderButton recordId={props.depotID} fileCount={depotFields.fileCount} fileUploaderConfigName="DepotScreen" isDash isPrevReload={pullDepotData} />
                        </span>
                        &nbsp;&nbsp;
                        <span >
                            {getAccessParam['CanUpdateDepots'] && (
                                <CustomButtonChip
                                    // className="btn-m"
                                    icon={AddIcon}
                                    label="Edit Depot"
                                    onClick={() => handleAddPopUp(null, 'showDepotScreen')}
                                // disabled={!getAccessParam['CanUpdateDepots']}
                                />
                            )}
                        </span>
                    </div>
                </Grid>
            </Grid>
        );
    };

    return (
        <div style={{ padding: '8px 4px 8px 0px' }}>
            <Grid container spacing={2}>
                {/* <Grid item xs={12}>
                    <AllStickyNotes
                        frompage="Depots"
                        // jobID={props?.scheduleJobID}
                        customerID={depotFields?.depotCustomerID}
                        depotID={props?.depotID || state?.depotID}
                        // NoteVehicleID={jobDetails?.jobVehicleID}
                        // variant="filled"
                    />
                </Grid> */}
                {/* <StickyNotes frompage="Customers" customerID={depotFields?.depotCustomerID} bgColor="#ffcf89" />
            <StickyNotes frompage="Depots" depotID={props?.depotID || state?.depotID} variant="filled" /> */}
                <Grid item xs={12}>
                    {state.showDepotScreen ? (
                        <AddEditDepots depotID={props.depotID} onFormClose={props.onFormClose} />
                    ) : (
                        <CustomizedTables tableHeader={Header()} tableData={tableData} />
                    )}
                </Grid>
            </Grid>
        </div>
    );
};

const Screen = (props) => {
    return (
        <DepotProvider {...props}>
            <EditDepotDash {...props} />
        </DepotProvider>
    );
};
export default Screen;
